"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryActionType = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Button_1 = __importStar(require("../button/Button"));
var SecondaryActionType;
(function (SecondaryActionType) {
    SecondaryActionType["ICON"] = "icon";
    SecondaryActionType["LINK"] = "link";
    SecondaryActionType["POPOVER"] = "popover";
})(SecondaryActionType = exports.SecondaryActionType || (exports.SecondaryActionType = {}));
var SecondaryAction = function (props) {
    var children = props.children, classes = props.classes, onClick = props.onClick, type = props.type, otherProps = __rest(props, ["children", "classes", "onClick", "type"]);
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default('fds-list-item-secondary', classes) }, otherProps), type === SecondaryActionType.POPOVER ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement(Button_1.default, { type: type === SecondaryActionType.LINK ? Button_1.ButtonType.ACTION : Button_1.ButtonType.ROUND, variant: type === SecondaryActionType.LINK ? Button_1.ActionButtonType.SECONDARY : Button_1.RoundButtonType.FLAT, onClick: onClick }, children))));
};
SecondaryAction.defaultProps = {};
exports.default = SecondaryAction;
